// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"ObjectsList_placeholder__2a7id","fade":"ObjectsList_fade__3rz47"};